<template>

    <!-- Navigation -->
    <section class="navigation">
        <h1>Navigation</h1>

        <!-- Navigation Information -->
        <ul class="navigation__info">
            <li>Pinch or mouse scroll to zoom in/out</li>
            <li>Select icons to view details</li>
            <li>Select below to jump steps</li>
        </ul>

        <!-- Navigation Steps -->
        <ul class="navigation__steps" ref="navigationSteps">
            <li v-for="(step, index) in steps" :key="index" @click="setTourStep(index)" :class="[ (touring && (tourStep == index)) ? 'active': '' ]">
                {{ step.name }}
            </li>
        </ul>

        <!-- Navigation Controls -->
        <div class="navigation__controls">
            <button @click="decrementTourStep" class="button button--prev">
                <span class="visually-hidden">Previous Step</span>
                <span class="icon icon--inline" aria-hidden="true">
                  <svg class="icon__svg" height="19" viewBox="0 0 29 31" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m11.4281435.38372676c-2.40318085-2.5530712.0780374 8.45133834-1.44829895 8.94026703 0 0-.97984455-1.32399379-9.43698596-.00451782-1.00649714 6.56841063-.31460716 6.44642953-.26483533 13.12929163 2.08488692 2.1961633 2.13711663-.5546881 9.86158274.7323891 1.3333936.3729713-.29002848 6.0734582.6574798 7.8188433 7.8233953-6.0990592 12.4792127-10.1369878 18.2429142-15.5307648-3.1214929-2.4777742-7.0129132-7.39316414-17.6118565-15.08550844z" fill="#ffffff" fill-rule="evenodd" transform="matrix(-1 0 0 1 29 0)"/></svg>
                </span>
            </button>
            <button @click="incrementTourStep" class="button button--next">
                <span class="visually-hidden">Next Step</span>
                <span class="icon icon--inline" aria-hidden="true">
                    <svg class="icon__svg" height="19" viewBox="0 0 29 31" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m11.4281435.38372676c-2.40318085-2.5530712.0780374 8.45133834-1.44829895 8.94026703 0 0-.97984455-1.32399379-9.43698596-.00451782-1.00649714 6.56841063-.31460716 6.44642953-.26483533 13.12929163 2.08488692 2.1961633 2.13711663-.5546881 9.86158274.7323891 1.3333936.3729713-.29002848 6.0734582.6574798 7.8188433 7.8233953-6.0990592 12.4792127-10.1369878 18.2429142-15.5307648-3.1214929-2.4777742-7.0129132-7.39316414-17.6118565-15.08550844z" fill="#ffffff" fill-rule="evenodd"/></svg>
                </span>
            </button>
        </div>
    </section>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                configuration: 'configuration',
                hasNextStep: 'hasNextStep',
                hasPreviousStep: 'hasPreviousStep',
                touring: 'touring',
                tourStep: 'tourStep',
                travelling: 'travelling',
            }),

            /*
             * Returns all steps
             *
             * @returns {array}
             */
            steps() {
                return this.configuration.steps
            },
        },

        methods: {
            ...mapActions({
                decrementTourStep: 'decrementTourStep',
                incrementTourStep: 'incrementTourStep',
                vuexSetTouring: 'setTouring',
                vuexSetTourStep: 'setTourStep',
            }),

            /*
             * Starts the tour and or jumps the tour to a specific step
             *
             * @param {integer} tourStep
             * @returns {void}
             */
            setTourStep(tourStep) {

                // Set touring to true
                this.vuexSetTouring(true)

                // Set the tour step
                this.vuexSetTourStep(tourStep)
            },

            /*
             * Determines the padding for the navigation steps while on mobile
             *
             * @returns {void}
             */
            calculateMobilePadding() {
                if (! this.$refs.navigationSteps.children[0].style.paddingLeft) {
                    this.$refs.navigationSteps.children[0].style.paddingLeft = `calc(50% - ${((this.$refs.navigationSteps.children[0].clientWidth / 2) + 8)}px)`
                    this.$refs.navigationSteps.children[(this.steps.length - 1)].style.paddingRight = `calc(50% - ${((this.$refs.navigationSteps.children[(this.steps.length - 1)].clientWidth / 2) - 8)}px)`
                }  
            },

            /*
             * Scrolls the navigation on mobile to create a centred view
             *
             * @returns {void}
             */
            mobileScrollNavigation() {
                this.$refs.navigationSteps.scrollLeft = (this.$refs.navigationSteps.children[this.tourStep].offsetLeft - (this.$refs.navigationSteps.clientWidth / 2) + (this.$refs.navigationSteps.children[this.tourStep].clientWidth / 2) + 8)
            },

            /*
             * Scrolls the navigation on desktop to ensure that the current step is always visible
             *
             * @returns {void}
             */
            desktopScrollNavigation() {

                // Determine if the tour step is not visible in the navigation and scroll accordingly
                if (this.$refs.navigationSteps.children[this.tourStep].offsetTop > (this.$refs.navigationSteps.clientHeight - 50)) {

                    // Navigation tour step is below the current scroll view, scroll downwards
                    this.$refs.navigationSteps.scrollTop = this.$refs.navigationSteps.children[this.tourStep].offsetTop
                } else if (this.$refs.navigationSteps.children[this.tourStep].offsetTop < this.$refs.navigationSteps.scrollTop) {

                    // Navigation tour step is above the current scroll view, scroll upwards
                    this.$refs.navigationSteps.scrollTop = this.$refs.navigationSteps.children[this.tourStep].offsetTop
                }
            },
        },

        watch: {

            /*
             * Upon tourStep value change (calculate padding and scroll)
             *
             * @param {integer} newStep
             * @param {integer} oldStep
             * @returns {void}
             */
            tourStep() {

                if (this.touring) {

                    if (this.steps) {

                        if (window.innerWidth >= 960) {
                            
                            this.desktopScrollNavigation()
                        } else {

                            this.calculateMobilePadding()
                            this.mobileScrollNavigation()
                        }
                    }
                }
            }
        }
  }
</script>
